import React from 'react';
import PropTypes from 'prop-types';
import { Viewer } from '../pacifa/pacifa3d-sdk.1.2.0.es';
import Zone from '../models/zone';
import { Overlay } from '../common/common';
import { useTranslation } from 'react-i18next';
import { detectSignificantSizeChange } from '../utils/detectSignificantSizeChange';

export default function ZoneSelector3d({
    pacifaKey,
    zone,
    onZoneSelected = () => {},
    onZoneOver = (zone, { x, y }) => {},
    onHidePopup = () => {},
    idFrame,
    onFrame = (iframe) => {},
    overlay = null,
}) {
    const { t } = useTranslation();
    React.useEffect(() => {
        const containerDiv = document.getElementById(idFrame + '-iframe-container');
        const viewer = new Viewer(containerDiv.id, pacifaKey, {
            requireCtrlOrMetaKeyToZoom: true,
            showZoomButtons: true,
            recenterOnWidowResize: false,
            requireCtrlOrMetaKeyToZoomWarning: t('requireCtrlOrMetaKeyToZoomWarning'),
        });
        const blockIds = zone.children.map((s) => s.pacifa_id);
        const blocksStyles = zone.children.map((s) => ({
            id: s.pacifa_id,
            css: s.style?.out,
            cssHover: s.style?.over,
        }));
        viewer
            .displayTopView({
                blockIds,
                included: true,
                blocksStyles,
            })
            .then(() => {
                const ref = viewer.containerEl.querySelector('iframe');
                ref.id = idFrame;
                // Slightly hacky way to hide the "ctrl+wheel" message if you click it
                ref.contentDocument.addEventListener('click', e => {
                    const warnMessage=ref.contentDocument.getElementById('requireCtrlOrMetaKeyToZoomWarning');
                    if(warnMessage?.style.opacity !== '0') {
                        warnMessage.style.display='none';
                        try{
                            window.sessionStorage.setItem('pacifa-knowsHowToZoomOnMap', 'yes');
                        }catch (e) {
                            console.warn(e);
                        }
                    }
                });
                onFrame(ref);
            });
        viewer.on('blockClicked', (blockId) => {
            const tmpZone = zone.children.find((zone) => zone.pacifa_id === blockId);
            if (tmpZone) {
                let final =
          tmpZone.seats &&
          tmpZone.seats.length &&
          (!tmpZone.children || !tmpZone.children.length);
                let ga = tmpZone.categories
                    ? tmpZone.categories.length === 1 &&
            tmpZone.categories[0].contingents.length === 1 &&
            !tmpZone.categories[0].contingents[0].seated
                    : false;
                const wrapped = new Zone.Child(tmpZone);
                onZoneSelected(wrapped, { ga, final });
            }
        });
        viewer.on('blockMouseMove', (blockId, ev) => {
            onZoneOver(
                zone.children.find((zone) => zone.pacifa_id === blockId),
                { x: ev.clientX, y: ev.clientY },
            );
        });
        viewer.on('blockMouseLeave', (blockId) => {
            onHidePopup();
        });
        // After menhir changes the size of the iframe , we re-center the pacifa map
        return detectSignificantSizeChange(containerDiv, () =>
            viewer.updateOnResize(),
        );
    }, [zone.pacifa_id, pacifaKey, idFrame]);
    return (
        <div id={idFrame + '-container'} className="frame-container">
            <div
                id={idFrame + '-iframe-container'}
                style={{ width: '100%', height: '100%' }}
            ></div>
            {overlay && <Overlay className={`${idFrame}-overlay`}>{overlay}</Overlay>}
        </div>
    );
}

ZoneSelector3d.propTypes = {
    pacifaKey: PropTypes.string.isRequired,
    zone: PropTypes.instanceOf(Zone).isRequired,
    onZoneSelected: PropTypes.func,
    onZoneOver: PropTypes.func,
    onHidePopup: PropTypes.func,
    idFrame: PropTypes.string.isRequired,
    onFrame: PropTypes.func,
    overlay: PropTypes.node,
};
